// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { variantColorStyles } from "@awc/App/Widgets/ProductDetails/ProductDetailsVariantCustomView";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

variantColorStyles.traitsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    `,
};

variantColorStyles.labelText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-bottom: 8px;
    `,
};

variantColorStyles.colorTrait = {
    css: css`
        border: 1px solid ${color("common.ui4")};
        border-radius: 100%;
        width: 26px;
        height: 26px;
        ${({ color }: any) =>
            color &&
            css`
                background-color: ${color};
            `}

        &.selected {
            box-shadow: 0 0 0 1px ${color("common.white")} inset;
            border-color: ${color("primary.main")};
        }
    `,
};
